<template>
  <div>
    <div class="row">
      <div class="col-8">
        <el-button type="warning" @click="onStart" v-if="this.accidentStatus === 35"><i class="fa-solid fa-play"></i>
          Başla
        </el-button>
        <div v-if="this.accidentStatus >= 40">
          <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
            "Müştəri xidməti tərəfindən iş başlanmışdır: " + data.createdBy
            }}</span>
        </div>
      </div>
      <!-- <div class="col-2" style="text-align: right">

        <el-button size="small" type="warning" @click="handleUser"><i class="fa-solid fa-user"></i>
          Məsul şəxsi dəyişdir </el-button>

      </div>
      <div class="col-2" style="text-align: right">

        <el-button size="small" type="warning"
          @click="openDialog">Geri qaytar</el-button>

      </div> -->
    </div>
    <br />
    <card v-if="this.accidentStatus >= 40">
      <div class="row">
        <div class="col-10">
          <div style="padding-bottom: 10px">
            <el-button size="small" type="primary" @click="newClaim" :disabled="!this.data"><i
                class="fa-solid fa-plus"></i> {{$t('Yeni_iş')}}</el-button>
          </div>
        </div>
      </div>
      <titles :text="$t('İşlər')"></titles>
      <hr width="100%" size="50" style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
        align="center">

      <el-form v-loading="loading">
        <div class="row">
          <div class="col-md-6" v-for="item in claims" :key="item.id">
            <claim-card class="clickable-card" :item="item" :linkid="item.linkId" @delete="deleteClaim"
              @refresh="getData" @click.native="handleCardClick($event, item.id)" />
          </div>
        </div>
      </el-form>

    </card>
    <el-collapse v-loading="loading" value="1">
      <el-collapse-item name="1">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-headphones-simple"></i>
            &nbsp;
            <span>{{ $t('Çağrı_mərkəzinin_qeydləri') }}</span>
          </div>
        </template>
        <accident-base :value="item"></accident-base>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="2" v-if="item.policyType==null || item.policyType==1 || item.policyType==2">
      <el-collapse-item name="2">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-person-military-pointing"></i>
            &nbsp;
            <span>{{$t('Komissarın_qeydləri')}}</span>
          </div>
        </template>
        <accident-comm-base :value="comm"></accident-comm-base>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="3">
      <el-collapse-item name="3">
        <template #title>
          <div style="margin-left: 7px;">
          <i class="fa-solid fa-people-arrows-left-right"></i>
          &nbsp;
          <span>{{$t('İştirakçılar')}}</span>
          </div>
        </template>
        <card>
          <div class="row">
            <div class="col-10">
              <div style="padding-bottom: 10px">
                <el-button size="small" type="primary" @click="handleClick" :disabled="!comm.id"><i
                    class="fa-solid fa-plus"></i> {{$t('Yeni_iştirakçı')}}</el-button>
              </div>
            </div>
          </div>

          <el-form v-loading="partloading">
            <div class="row">
              <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
                <div v-if="item.policyType === null || item.policyType === 1">
                  <participant-card :item="item" @refresh="getParticipants" @edit="editParticipant(item)"
                    @delete="deleteParticipant" @report="reportParticipant(item)" />
                </div>
                <div v-else>
                  <other-participant-card :item="item" @refresh="getParticipants" @edit="editParticipant(item)"
                    @delete="deleteParticipant" @report="reportParticipant(item)" />
                </div>
              </div>
            </div>
          </el-form>

        </card>
      </el-collapse-item>
    </el-collapse>
    <el-dialog :visible.sync="rejectVisible" width="30%" top="30vh" title="Səbəb">
      <el-input v-model="comm.rejectReason" :placeholder="$t('Səbəb')"></el-input>
      <div style="height: 20px;"></div>

      <CommUsers v-model="comm.accidentCommUid" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="checkReasonBeforeConfirm()">{{$t('Bəli')}}</el-button>
        <el-button size="small" @click="rejectVisible = false">{{$t('Xeyr')}}</el-button>
      </span>
    </el-dialog>
    <participant ref="participant" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
    <new-claim ref="claim" @saved="getClaimParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <client-service-user @refresh="getData" ref="user" />
  </div>
</template>

<script>
  import {
    GetAccident,
    GetCommData,
    GetParticipants,
    ClientServiceStart,
    GetAccidentsByStatus,
    DeleteParticipant,
  } from "../../services/accident";
  import { DeleteClaim } from "../../services/claim";
  import { GetClaimParticipants, LastAccidentStatus } from "../../services/common";
  import Participant from "../components/Participant.vue";
  import OtherParticipant from "../components/OtherParticipant.vue";
  import ReportParticipant from "../components/ReportParticipant.vue";
  import ParticipantCard from "../components/ParticipantCard.vue";
  import OtherParticipantCard from "../components/OtherParticipantCard.vue";
  import NewClaim from "./NewClaim.vue";
  import ClaimCard from "../components/ClaimCard.vue";
  import AccidentBase from "../components/AccidentBase.vue";
  import AccidentCommBase from "../components/AccidentCommBase.vue";
  import ClientServiceUser from "./ClientServiceUser.vue";
  import Titles from "../components/Titles.vue";
  export default {
    props: {
      id: [String, Number],
    },
    components: {
      Titles,
      Participant,
      ClaimCard,
      AccidentBase,
      AccidentCommBase,
      NewClaim,
      ParticipantCard,
      ReportParticipant,
      ClientServiceUser,
      OtherParticipant,
      OtherParticipantCard
    },
    data() {
      return {
        loading: false,
        commloading: false,
        partloading: false,
        item: {},
        comm: {},
        data: {},
        participants: [],
        claims: {},
        uid: this.$store.state.user.id,
        rejectVisible: false,
        accidentStatus: null
      };
    },
    computed: {

      isFormDisabled() {
        return (this.accidentStatus >= 11 && this.accidentStatus <= 13) || this.accidentStatus >= 30;
      },

    },
    methods: {
      handleCardClick(event, id) {
        const isDropdownClick = event.target.closest('.el-dropdown') ||
          event.target.closest('.el-dropdown-menu') ||
          event.target.closest('.custom-button');

        if (!isDropdownClick) {
          this.clickCard(id);
        }
      },
      clickCard(id) {
        this.$router.push({
          path: "../claim/" + id,
        });
      },
      openDialog() {
        this.rejectVisible = true;
      },

      newClaim() {
        this.$refs["claim"].new(this.comm.accidentId);
      },
      newParticipant() {
        this.$refs["participant"].new(this.comm.accidentId);
      },
      newOtherParticipant() {
        this.$refs["otherParticipant"].new(this.comm.accidentId);
      },
      map() {
        this.$refs["mapcontrol"].show(this.comm.lat, this.comm.lng);
      },
      lastAccidentStatus() {
        LastAccidentStatus(this.id).then((response) => {
          if (response) {
            
            this.accidentStatus = response.data;
          } else {
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      onStart() {
        this.$confirm("Hadisə üzrə iş başlandı?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.loading = true;
          ClientServiceStart(this.id, this.uid).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Uğurlu əməliyyat",
                });
                this.getDataByStatus();
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          });
        });
      },

      getCommData() {
        this.commloading = true;
        GetCommData(this.id).then((response) => {
          this.commloading = false;
            if (response && response.data && response.data.data && response.data.data?.[0]) {
      this.comm = response.data.data?.[0];
    } else {
      this.comm = {};
    }
        });
      },

      getData() {
        this.loading = true;
        GetAccident(this.id).then((response) => {
          this.loading = false;
          if (response.data) {
             this.item = response.data.data?.[0]
            this.getCommData();
            this.getParticipants();
            this.getDataByStatus();
            this.getClaimParticipants();
            this.lastAccidentStatus();
          } else {
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      getDataByStatus() {
        this.loading = true;
        GetAccidentsByStatus(this.id, 0, 40, this.uid).then((response) => {
          this.loading = false;
          if (response.data) {
            this.data = response.data.data?.[0];
          } else {
            this.data = null;
          }
        });
      },
      getParticipants() {
        this.partloading = true;
        GetParticipants(this.id).then((response) => {
          this.partloading = false;
          if (response.data.data) {
            this.participants = response.data.data;
          }
        });
      },
      handleClick() {
        if (this.item.policyType === null || this.item.policyType === 1) {
          this.newParticipant();
        } else {
          this.newOtherParticipant();
        }
      },
      getClaimParticipants() {
        this.partloading = true;
        GetClaimParticipants(this.id).then((response) => {
          this.partloading = false;
          if (response.data) {
            this.claims = response.data.data;
          }
        });
      },

      editParticipant(item) {
        if (this.item.policyType === 1 && this.item.policyType)
          this.$refs["participant"].edit(item.id, false);
        else
          this.$refs["otherParticipant"].edit(item.id, false);

      },

      reportParticipant(item) {
        // let shouldEdit = item.createUser === this.uid;
        this.$refs["report"].edit(item.id, item.accidentId, item.createUserId, false);
      },

      deleteClaim(id) {
        this.$confirm("İş ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            this.loading = true;
            DeleteClaim(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message:response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "İş ləğv olundu",
                  });
                  this.getClaimParticipants();
                }
              } else {
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
      deleteParticipant(id) {
        if (this.isDeleting) return;
        this.isDeleting = true;

        this.$confirm("İştirakçı ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false
        }).then(() => {
          this.partloading = true;

          DeleteParticipant(id, this.uid).then((response) => {
            this.partloading = false;
            this.isDeleting = false;

            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message:  response.data.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: "Ləğv olundu",
                });
                this.getParticipants();
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          }).catch(() => {
            this.partloading = false;
            this.isDeleting = false;
            this.$message({
              type: "error",
              message: "Xəta baş verdi",
            });
          });

        }).catch(() => {
          this.isDeleting = false;
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        });
      },
      handleUser() {
        this.$refs["user"].edit(this.item);
      },
    },

    mounted() {
      this.getData();
    },
  };
</script>

<style lang="scss" scoped>

</style>